import {
  FetchAssetsResponse,
  LibraryAsset,
  useCreateAssetsServiceInstance,
} from '@zoomcatalog/design-system';
import api from '@/config/axios';
import { GET_ASSET_LIBRARY } from '@/config/endpoints';
import { useSelector } from '@/store/rootStore';

export function useSetupServices() {
  const endpoints = useSelector((state) => state.sniffer.endpoints);

  const assetsInstance = useCreateAssetsServiceInstance({
    async getPreSignedUrl(data) {
      let assets = [
        {
          is_for_company: false,
          is_public: true,
          filename: data.filename,
        },
      ];

      if (Array.isArray(data.filename)) {
        assets = data.filename.map((name) => ({
          is_for_company: false,
          is_public: true,
          filename: name,
        }));
      }

      return api
        .post<{
          res: Array<{
            fields: {
              AWSAccessKeyId: string;
              acl: string;
              'content-type': string;
              key: string;
              policy: string;
              signature: string;
              success_action_status: string;
            };
            url: string;
            uuid: string;
          }>;
        }>(
          '/asset/upload',
          {
            assets,
            tags: data.tags,
          },
          {
            baseURL: endpoints.value.ASSET_SERVICE_API_ENDPOINT,
          }
        )
        .then((response) => response.data);
    },
    getResizeUrl(assetId, [width, height]) {
      return `${
        endpoints.value.ASSET_SERVICE_API_ENDPOINT
      }/asset/${assetId}/resize/${width}x${height ?? ''}`;
    },
    async getAssetsQuery(data) {
      const { endpoint } = GET_ASSET_LIBRARY;

      return api
        .get<FetchAssetsResponse>(endpoint(data.tags), {
          baseURL: endpoints.value.ASSET_SERVICE_API_ENDPOINT,
          headers: {
            'Cache-Control': 'max-age=0',
          },
          params: {
            limit: data.limit,
            sort: '-created',
            offset: data.offset,
          },
        })
        .then((data) => data.data);
    },
    async uploadSingleAsset(assetData, formData) {
      return api
        .post(assetData.url, formData, {
          baseURL: undefined,
          transformRequest: (data, headers) => {
            if (headers) {
              // TODO: Check why headers.common is set to string instead of object
              delete (headers.common as unknown as Record<string, string>)
                .Authorization;
            }
            return data;
          },
        })
        .then(() => ({ data: assetData }));
    },
    getOriginalUrl() {
      return '';
    },
    getAssetImprintAreasQuery() {
      return Promise.resolve({
        metadata: {
          limit: 0,
          offset: 0,
          total_available: 0,
        },
        objects: [],
      });
    },
    async getAssetById(assetId, params) {
      return api
        .get<LibraryAsset>(`/asset/${assetId}`, {
          baseURL: endpoints.value.ASSET_SERVICE_API_ENDPOINT,
          params,
        })
        .then((data) => data.data);
    },
  });

  return {
    assetsInstance,
  };
}
